import { createSelector } from 'reselect';

import { GlobalState } from 'ha/types/store';

export const getCurrentSorting = (state: GlobalState) =>
  state.search.sorting.currentSorting;

export const getSortingOptions = (state: GlobalState) =>
  state.search.sorting.indexes;

export const getCurrentIndex = createSelector(
  [getCurrentSorting, getSortingOptions],
  (currentSorting, sortingOptions) =>
    sortingOptions && sortingOptions[currentSorting],
);
